import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class DiningtablesService {


  constructor(private http: HttpClient,
    private loginService:LoginService
  ) { }

  url = environment.serverAPI5 + "/api"

  url1 = environment.serverAPI + "/api"

  createTable(currencies: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/diningTable`, currencies)
  }

  getTableById(id: number): Observable<Object> {
    let authourized = this.loginService.getAuthenticatedUser();
    if(authourized){
      return this.http.get(`${this.url}/diningTable/${id}`);
    }else{
      return this.http.get(`${this.url}/ig/diningTable/${id}`);
    }
    
  }
  getTableInfobyId(id: any): Observable<Object> {
    return this.http.get(`${this.url}/sales/table/${id}`);
  }

  getTableByIdByIg(id: number): Observable<Object> {
    return this.http.get(`${this.url}/ig/diningTable/${id}`);
  }

  getAllTable(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/diningTable?page=${Page}&size=${size}&sort=${sort}`);
  }

  TableSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/diningTable/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByTableId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/diningTable/${id}`);
  }
  downloadTableTemplate(): Observable<any> {
    return this.http.get(`${this.url}/diningTable/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downloadTableReport(Page: number, size: number, sort, selectionCurriences): Observable<any> {
    return this.http.post(`${this.url}/diningTable/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionCurriences, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  getAllTableDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/diningTable/dropdown`);
  }

  getAllWaiterDropDown(type :any): Observable<Object> {
    return this.http.get(`${this.url}/user/dropdown/${type}`);
  }

  getAllWaiterTableById(id :any): Observable<Object> {
    return this.http.get(`${this.url}/table/waiter/${id}`);
  }

  tableNoExits(value: any): Observable<Object> {
    return this.http.get(`${this.url}/table/exits/${value}`);
  }

}
